<template>
    <div  class="mt-50 mb-0">

        <a-row>
            <a-col :span="8">
                
            </a-col>
            <a-col :span="8">
                <a-result class="font-web" status="500" title="503" sub-title="Sorry 503 (Service unavailable), the server is maintenance">
                    <template #extra>
                        
                    </template>
                    <div class="desc">
                        <p class="font-web" style="font-size: 18px;">
                            <strong>Scheduled System Maintenance Notification:</strong>
                        </p>
                        <p class="font-web mt-0 mb-0" style="font-size: 18px;">Dear Faculty and Staff,</p>
                        <p class="font-web mt-0 mb-0" style="font-size: 16px;">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;We would like to inform you that our IT system will undergo scheduled maintenance to enhance its performance and reliability. During this period, the system will be temporarily unavailable.
                        </p>
                        <a-alert
                            class="mt-20 mb-20"
                            type="error"
                        >
                            <div slot="message">
                                <p class="font-web mt-0 mb-0" style="font-size: 18px;">Maintenance Schedule:</p>
                            </div>
                            <div slot="description">
                                <p class="font-web mt-0 mb-0 ml-20" style="font-size: 18px;"><a-icon class="mr-10" :style="{ color: 'red' }" type="close-circle" /> Expected Completion: Within 21:50 - 23:00 </p>
                            </div>
                        </a-alert>
                        
                        
                        <p class="font-web mt-0 mb-0" style="font-size: 16px;">
                            This maintenance is essential to ensure that our system continues to provide you with the best possible experience. We are committed to completing the process as quickly as possible and minimizing any inconvenience.
                        </p>
                        <p class="font-web mt-20 mb-20" style="font-size: 16px;">We appreciate your understanding and patience during this time. Should you have any questions or require assistance, please feel free to contact our support team</p>
                        <p class="font-web mt-20 mb-20" style="font-size: 16px;">Thank you for your cooperation.</p>
                        <p class="font-web mt-20 mb-0" style="font-size: 18px;">Best regards,</p>
                        <p class="font-web mt-0 mb-0" style="font-size: 18px;">Information Technology Section</p>
                        <p class="font-web mt-0 mb-0" style="font-size: 18px;">Mahidol University International College</p>
                    </div>
                </a-result>
            </a-col>
            <a-col :span="8">
                
            </a-col>
        </a-row>
        
    </div>
  </template>
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  